export default __webpack_public_path__ + "static/media/grafana.1e0deb6b.svg";